import { useCacheStore } from '@/stores/cache-store'
import { keyBuilderService } from '../../services/key-builder'
import { ttlService } from '../../services/ttl'

/**
 * Cache'e veri ekler
 * @param {string} prefix - Cache anahtarı için önek
 * @param {Object} params - Cache anahtarının parametreleri
 * @param {any} data - Cache'lenecek veri
 * @param {Object} options - Cache seçenekleri
 * @returns {string} Oluşturulan cache anahtarı
 */
export const set = (prefix, params, data, options = {}) => {
  const cacheStore = useCacheStore()
  const key = keyBuilderService.build(prefix, params)
  
  // TTL'i parse et (string veya sayı olabilir)
  const defaultTTL = "2m" // 2 dakika
  const ttl = options.ttl !== undefined ? 
    ttlService.parse(options.ttl) : 
    ttlService.parse(defaultTTL)
  
  cacheStore.set(key, data, { 
    ttl, 
    metadata: { 
      prefix,
      params,
      ...options.metadata || {}
    } 
  })
  
  // İstatistik için
  if (typeof window !== 'undefined' && window.__CACHE_STATS__) {
    window.__CACHE_STATS__.sets = (window.__CACHE_STATS__.sets || 0) + 1
  }
  
  if (process.env.VUE_APP_MODE === 'development') {
    const _estimateSize = (data) => {
      try {
        const str = JSON.stringify(data)
        const bytes = new Blob([str]).size
        
        if (bytes < 1024) {
          return `${bytes} B`
        } else if (bytes < 1024 * 1024) {
          return `${Math.round(bytes / 1024)} KB`
        } else {
          return `${Math.round(bytes / (1024 * 1024))} MB`
        }
      } catch (e) {
        return 'hesaplanamadı'
      }
    }
    
    console.log(`🔵 Cache SET: ${key}`, { 
      params, 
      ttl: ttl ? ttlService.format(ttl) : 'sınırsız',
      size: _estimateSize(data)
    })
  }
  
  return key
}